export default {
  existing_documents: {
    description: 'Ya has subido los siguientes documentos. Selecciona uno y pulsa enviar, o sube un nuevo documento.',
    sides: {
      front: 'Anverso',
      back: 'Reverso',
    },
    created_at: 'Subido: {{date}}',
    expires_at: 'Vence: {{date}}',
  },
  document_types: {
    owner_document: 'Documento de identidad del propietario',
    business_document: 'Documento comercial',
  },
  form: {
    document_type: {
      label: 'Documento de prueba de identidad',
      placeholder: 'Seleccionar tipo de documento',
      options: {
        passport: 'Pasaporte',
        driver_license: 'Permiso de conducir',
        id_card: 'Tarjeta de identidad',
        residence_permit: 'Permiso de residencia',
      },
    },
    front: {
      label: 'Anverso del documento',
    },
    back: {
      label: 'Reverso del documento (opcional para algunos documentos)',
    },
    expires_at: {
      label: 'Fecha de vencimiento del documento',
      placeholder: 'Seleccionar fecha de vencimiento',
    },
  },
  buttons: {
    select_file: 'Seleccionar archivo',
    next: 'Siguiente',
    back: 'Reverso',
    send: 'Enviar',
    upload_new: 'Subir nuevo documento',
    use_existing: 'Usar un documento subido',
  },
};
